import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { KeywordsWordCloud, KeywordsWordCloud_cloud } from "../data/dummy";
import { Header, Button } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { AgentName, intentTypeData, sentimentTypeData } from "../data/dummy";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const VisualizeWordFrequency = () => {
  const [userId, setUserId] = useState('');
  const [unixTime, setUnixTime] = useState('');
  const { currentColor } = useStateContext();
  const containerHeight = Math.max(500, KeywordsWordCloud.length * 25 * 1.2);
  const location = useLocation();
  // 키워드별 색상 상태 관리
  const navigate = useNavigate();

  // 키워드 및 색상 상태 관리
  const [keywords, setKeywords] = useState(location.state?.keywords || []);
  const [keywordColors, setKeywordColors] = useState(location.state?.keywordColors || {});

  // 상세 페이지로 이동
  const handleEditClick = () => {
    navigate("/vis/wordfreq-detail", { state: { keywords, keywordColors } });
  };



  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { beginAtZero: true },
    },
    plugins: {
      legend: { display: false },
    },
  };

  useEffect(() => {
    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);
  }, [])

  const handleDataset = (intentName, sentiment) => {
    const keywords = KeywordsWordCloud_cloud[intentName][sentiment];
    
    return (
      <div className="flex-1" style={{ height: `${Math.max(500, keywords.length * 25 * 1.2)}px` }}>
        <div className="flex gap-5">
          <p className="text-s">{sentiment} 리뷰</p>
          <Button
            color="white"
            bgColor={currentColor}
            text="차트 편집하기"
            borderRadius="10px"
            onClick={() => navigate("/vis/wordfreq-detail",
              { state: { keywords, keywordColors, intentName, sentiment } })}
          />
        </div>
        <Bar data={{
          labels: keywords.map((item) => item.text),
          datasets: [
            {
              label: "키워드 빈도",
              data: keywords.map((item) => item.value),
              backgroundColor: keywords.map(
                (item) => keywordColors[item.text] || "rgba(75, 192, 192, 0.5)"
              ),
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 1,
            },
          ],
        }} options={options} />
      </div>
    )
  }

  return (
    <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
      <Header category="데이터 시각화" title="키워드 빈도 차트" />

      <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
        {intentTypeData.map((intentName, index) => (
          <div>
            <p className="text-xl font-semibold">{intentName} 리뷰</p><br />
            <div className="flex gap-5">
              {
                sentimentTypeData.map((sentiment, index) => (
                  handleDataset(intentName, sentiment)
                ))
              }
            </div>
            <br /><br />
            <hr className="my-8 border-gray-300" />
          </div>
        ))
        }

      </div>
    </div>
  );
};

export default VisualizeWordFrequency;
